module.exports = __webpack_public_path__ + "img/prostate-cancer-leaflet.b29b3325.jpg";